import { Model } from "@interfaces/model.interface";

export interface OutsideProcessContractContingencySupplier extends Model {
	notes: string;
	outsideProcessContractId: number;
	supplierId: number;
}

export class OutsideProcessContractContingencySupplier implements OutsideProcessContractContingencySupplier {
	constructor(data?: Partial<OutsideProcessContractContingencySupplier>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}